import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import './autocomplete.css';

import { Model } from '../../../models/model';

const filter = createFilterOptions();

export const AutocompleteProjects = ({ form, handleChange }) => {

    const [projectList, setProjectList] = useState([])

    useEffect(() => {
        getProjects()
    }, [])

    const getProjects = async () => {
        const resultList = await Model.getAll({
            url: 'projects/list-to-link/all'
        })

        setProjectList(resultList)
    }

    return (
        <Autocomplete
            value={projectList.find((it) => (it.id === form.id_proyecto)) || null}
            onChange={(e, newValue) => handleChange(e, newValue)}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                // const { inputValue } = params;

                // Suggest the creation of a new value
                // const isExisting = options.some((option) => inputValue === option.nombre);
                // if (inputValue !== '' && !isExisting) {
                //     filtered.push({
                //         inputValue,
                //         nombre: `Crear  "${inputValue}"`,
                //     });
                // }

                return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id="free-solo-with-text-demo"
            options={projectList}
            getOptionLabel={(option) => {

                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }

                // Add "xxx" option created dynamically
                if (option.inputValue) {
                    return option.inputValue;
                }

                // Regular option
                return option.nombre;
            }}
            renderOption={(props, option) => <li {...props}>{option.nombre}</li>}
            sx={{ width: '100%' }}
            size='small'
            freeSolo
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Seleccionar proyectos"
                    placeholder='Ingrese nombre proyecto'
                />
            )}
            disabled={form.reading_mode}
        />
    );
}